import axios from 'axios'
import constants from '../constants/constants'
// TODO fix
// eslint-disable-next-line import/no-cycle
import { updateField } from './index'
import { postLocalNotification } from './notifications'
import {
  LIKE_REVIEW,
  UNLIKE_REVIEW,
  FETCHING_REVIEWS_AMBASSADOR_INITIAL,
  FETCHING_REVIEWS_AMBASSADOR_MORE,
  RECEIVED_REVIEWS_AMBASSADOR_INITIAL,
  RECEIVED_REVIEWS_AMBASSADOR_MORE,
  ERROR_FETCHING_REVIEWS_AMBASSADOR_INITIAL,
  ERROR_FETCHING_REVIEWS_AMBASSADOR_MORE
} from './constants/reviews'
import * as types from '../constants/actionTypes'

export const like =
  ({ reviewID, viewerID, toLike }) =>
  (dispatch) => {
    // return if there's no viewer or review
    if (!reviewID || !viewerID) return

    dispatch({
      type: toLike ? LIKE_REVIEW : UNLIKE_REVIEW,
      reviewID,
      viewerID
    })
    if (toLike) {
      axios.post(`${constants.api.reviews + reviewID}/likes`, {
        platform: 'web'
      })
    } else {
      axios.delete(`${constants.api.reviews + reviewID}/likes`, {
        platform: 'web'
      })
    }
  }

export const likeComment =
  ({ reviewID, commentID, viewerID, type }) =>
  (
    dispatch
    // TODO fix
    // eslint-disable-next-line sonarjs/cognitive-complexity
  ) => {
    dispatch({
      type: type === 'like' ? types.LIKING_COMMENT : types.UNLIKING_COMMENT,
      reviewID,
      commentID,
      viewerID
    })

    axios
      .put(`${constants.api.reviews}comments/${commentID}/like`, {
        type
      })
      .then((res) => {
        if (!res.data.success) {
          // restore original state
          dispatch({
            type:
              type === 'like' ? types.UNLIKING_COMMENT : types.LIKING_COMMENT,
            reviewID,
            commentID,
            viewerID
          })
        }
      })
      .catch((err) => {
        console.error(err)
        // restore original state
        dispatch({
          type: type === 'like' ? types.UNLIKING_COMMENT : types.LIKING_COMMENT,
          reviewID,
          commentID,
          viewerID
        })
      })
  }

export const report =
  ({ reviewID, viewerID, text }) =>
  (dispatch) => {
    if (!reviewID || !viewerID || !text) return

    axios.post(constants.api.reports, {
      review: reviewID,
      type: 'review',
      text,
      platform: 'web'
    })
    dispatch(
      postLocalNotification(
        'Thank you for your report. We are looking into it.'
      )
    )
  }

export const comment =
  ({ review, viewer, text }) =>
  // eslint-disable-next-line complexity, sonarjs/cognitive-complexity
  (dispatch) => {
    // return if viewer is not loaded yet
    if (!review || !viewer._id || !text) {
      return
    }
    // eslint-disable-next-line no-shadow
    const comment = {}
    comment.review = review._id
    comment.text = text
    if (review.responseTo && review.responseTo.restaurant) {
      comment.restaurant = review.restaurant._id
    } else {
      comment.receiver = review.responseTo
        ? review.responseTo.user._id
        : review.user._id
    }
    comment.responseTo = review.responseTo
      ? review.responseTo.responseTo || review.responseTo._id
      : null
    comment.platform = 'web'

    dispatch(
      updateField({
        type: 'reviews',
        _id: review._id,
        value: { isLoading: true }
      })
    )

    axios
      .put(`${constants.api.reviews + review._id}/comments`, comment)
      .then((res) => {
        dispatch(
          updateField({
            type: 'reviews',
            _id: review._id,
            value: { isLoading: false }
          })
        )
        if (res.data.success) {
          // add metadata to the comment
          comment._id = res.data._id
          comment.user = viewer
          comment.createdAt = Date.now()
          comment.restaurant = null
          comment.brand = null
          comment.likes = []
          // comment.business = null

          dispatch(
            updateField({
              type: 'reviews',
              _id: review._id,
              value: {
                comments: review.comments.concat(comment),
                comment: '',
                responseTo: null
              }
            })
          )
        }
      })
      .catch((err) => {
        console.error(err)

        dispatch(
          updateField({
            type: 'reviews',
            _id: review._id,
            value: { isLoading: false }
          })
        )
      })
  }

export const post = () => {}

export const fetchAmbassadorFeedReviews =
  ({ ambassadorID, skip = 0, limit = 10, isNewSearch = false }) =>
  (dispatch) => {
    const token =
      window?.localStorage?.token ?? constants.keys.LOGGED_OUT_ACCESS_TOKEN

    dispatch({
      type: isNewSearch
        ? FETCHING_REVIEWS_AMBASSADOR_INITIAL
        : FETCHING_REVIEWS_AMBASSADOR_MORE
    })
    axios
      .get(
        `${constants.api.ambassadors}influencers/${ambassadorID}/feed?skip=${skip}&limit=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )
      .then((res) => {
        dispatch({
          type: isNewSearch
            ? RECEIVED_REVIEWS_AMBASSADOR_INITIAL
            : RECEIVED_REVIEWS_AMBASSADOR_MORE,
          data: res.data
        })
      })
      .catch(() => {
        dispatch({
          type: isNewSearch
            ? ERROR_FETCHING_REVIEWS_AMBASSADOR_INITIAL
            : ERROR_FETCHING_REVIEWS_AMBASSADOR_MORE
        })
      })
  }
